import { isUploadTokenGated, MAX_SAMPLES_PER_PACK, SamplePack } from '@arpeggi/shared'
import { useSnackbar } from 'notistack'
import { useMemo, useState } from 'react'
import { copyToClipboard } from '../../../__legacy__/components/core/Utils'
import { useArpMedias } from '../../../__legacy__/queries/arpMedia'
import { useIsSPEditionHolder } from '../../token-gating/hooks'
import { useShowUploadDownload, useSPTweet } from '../hooks'

export const useSPActions = (sp: SamplePack) => {
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false)
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false)
  const { isHolder } = useIsSPEditionHolder(sp)
  const showUploadDownload = useShowUploadDownload(sp, isHolder)
  const hasProject = !!sp.project
  const tweet = useSPTweet(sp)
  const uploadDisabled = isUploadTokenGated(sp) && !isHolder
  const samplePackLink = `${window.location.origin}/sample-packs/${sp.id}`
  const { enqueueSnackbar } = useSnackbar()
  const soundsQuery = useArpMedias(
    { samplePackId: sp.id, perPage: MAX_SAMPLES_PER_PACK },
    { enabled: showUploadDownload }
  )
  const sounds = useMemo(
    () => soundsQuery.data?.pages.flatMap((page) => page.data.map((sound) => sound)) || [],
    [soundsQuery.data]
  )

  const handleCopy = () => {
    copyToClipboard(samplePackLink)
    enqueueSnackbar('Sample pack link copied!', {
      variant: 'modalSuccess'
    })
  }

  return {
    isDownloadModalOpen,
    isUploadModalOpen,
    setIsDownloadModalOpen,
    setIsUploadModalOpen,
    isHolder,
    showUploadDownload,
    hasProject,
    tweet,
    uploadDisabled,
    samplePackLink,
    handleCopy,
    soundsQuery,
    sounds
  }
}
